A party that contributes to a workflow process.

This may be a person, organization, or both.
